import type { BadgeStatusVariant } from '@/shared/ui/Badge'

export type MissionShowStatus =
  | 'not_started'
  | 'available'
  | 'pending'
  | 'approved'
  | 'refused'
  | 'expired'

export const MISSION_SHOW_STATUS_LABELS: Record<MissionShowStatus, string> = {
  not_started: 'Não iniciada',
  available: 'Disponível',
  pending: 'Em validação',
  approved: 'Concluída',
  refused: 'Requer correção',
  expired: 'Encerrada'
}

export const MISSION_SHOW_STATUS_BADGE: Record<
  MissionShowStatus,
  BadgeStatusVariant
> = {
  not_started: 'locked',
  available: 'available',
  pending: 'progress',
  approved: 'success',
  refused: 'expired',
  expired: 'expired'
}

export const MISSION_SHOW_STATUS_HINTS: Record<MissionShowStatus, string> = {
  not_started: 'Esta missão ainda não está aberta para participação.',
  available: 'Você ainda não enviou uma evidência.',
  pending: 'Sua evidência foi enviada.',
  approved: 'Recompensas recebidas.',
  refused: 'Envie novamente.',
  expired: 'Prazo expirado.'
}

export type MissionHeroBadge = {
  label: string
  className: string
}

export const MISSION_HERO_BADGE: Record<MissionShowStatus, MissionHeroBadge> = {
  available: {
    label: 'Missão ativa',
    className: 'bg-orange-500/20 text-orange-200'
  },
  pending: {
    label: 'Em validação',
    className: 'bg-orange-500/15 text-orange-200'
  },
  approved: {
    label: 'Concluída',
    className: 'bg-green-500/20 text-green-200'
  },
  refused: {
    label: 'Reprovada',
    className: 'bg-red-500/20 text-red-200'
  },
  expired: {
    label: 'Encerrada',
    className: 'bg-black/25 text-white/70'
  },
  not_started: {
    label: 'Em breve',
    className: 'bg-white/15 text-white/80'
  }
}
